import InboxRuleStore from '../store/schema/InboxRuleStore';
import inboxRuleStore from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';

export interface SetInboxRuleSelectedFolderIdState {
    inboxRuleStore: InboxRuleStore;
}

/**
 * Set the selectedFolderId in inbox rule store
 * @param folderId the folderId to set
 * @param state the state which contains the inbox rule store
 */
export default action('setInboxRuleSelectedFolderId')(
    select({
        inboxRuleStore: () => inboxRuleStore,
    })(function setInboxRuleSelectedFolderId(
        folderId: string,
        state?: SetInboxRuleSelectedFolderIdState
    ) {
        state.inboxRuleStore.selectedFolderId = folderId;
    })
);
